var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCallHelpLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3561 13.1441C10.1861 11.9741 9.30415 10.6641 8.71815 9.33512C8.59415 9.05412 8.66715 8.72512 8.88415 8.50812L9.70315 7.69012C10.3741 7.01912 10.3741 6.07012 9.78815 5.48412L8.61415 4.31012C7.83315 3.52912 6.56715 3.52912 5.78615 4.31012L5.13415 4.96212C4.39315 5.70312 4.08415 6.77212 4.28415 7.83212C4.77815 10.4451 6.29615 13.3061 8.74515 15.7551C11.1941 18.2041 14.0551 19.7221 16.6681 20.2161C17.7281 20.4161 18.7971 20.1071 19.5381 19.3661L20.1891 18.7151C20.9701 17.9341 20.9701 16.6681 20.1891 15.8871L19.0161 14.7141C18.4301 14.1281 17.4801 14.1281 16.8951 14.7141L15.9921 15.6181C15.7751 15.8351 15.4461 15.9081 15.1651 15.7841C13.8361 15.1971 12.5261 14.3141 11.3561 13.1441Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallHelpLine);
export default __webpack_public_path__ + "static/media/CallHelpLine.3aebbcfc79e5f73ae9e7dc7bdbc70256.svg";
export { ForwardRef as ReactComponent };